import React, { useState } from 'react';
import { QrCode, Calendar, Download, Plus, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function PermitsScreen() {
  const [showModal, setShowModal] = useState(false);
  const [selectedPermit, setSelectedPermit] = useState<any>(null);
  const permits = [{
    id: 1,
    name: 'Trout Stamp',
    price: 25,
    duration: 'Annual',
    desc: 'All inland trout waters'
  }, {
    id: 2,
    name: 'Salmon Tag',
    price: 45,
    duration: 'Season',
    desc: 'Coastal rivers & bays'
  }, {
    id: 3,
    name: 'Lake Pass',
    price: 15,
    duration: 'Daily',
    desc: 'State park lakes'
  }];
  return <div className="p-4 md:p-8 max-w-2xl mx-auto pb-24 md:pb-8" data-id="element-176">
      <header className="mb-6" data-id="element-177">
        <h1 className="text-2xl font-semibold text-[var(--text-primary)]" data-id="element-178">
          Permits
        </h1>
        <p className="text-[var(--text-secondary)] text-sm mt-1" data-id="element-179">
          Your licenses and tags
        </p>
      </header>

      {/* Active Permit */}
      <div className="card p-5 mb-6 bg-gradient-to-br from-teal-500 to-emerald-600 text-white" data-id="element-180">
        <div className="flex justify-between items-start mb-6" data-id="element-181">
          <div data-id="element-182">
            <p className="text-teal-100 text-xs font-medium uppercase tracking-wide" data-id="element-183">
              Annual License
            </p>
            <h2 className="text-xl font-semibold mt-1" data-id="element-184">Sport Fishing</h2>
          </div>
          <div className="p-2 bg-white/20 rounded-xl" data-id="element-185">
            <QrCode className="w-10 h-10" data-id="element-186" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm mb-6" data-id="element-187">
          <div data-id="element-188">
            <p className="text-teal-100 text-xs" data-id="element-189">Holder</p>
            <p className="font-medium" data-id="element-190">John Doe</p>
          </div>
          <div data-id="element-191">
            <p className="text-teal-100 text-xs" data-id="element-192">ID</p>
            <p className="font-mono font-medium" data-id="element-193">#8829-1029</p>
          </div>
          <div data-id="element-194">
            <p className="text-teal-100 text-xs" data-id="element-195">Valid</p>
            <p className="font-medium" data-id="element-196">Jan 1 - Dec 31, 2024</p>
          </div>
          <div data-id="element-197">
            <p className="text-teal-100 text-xs" data-id="element-198">Status</p>
            <div className="flex items-center space-x-1" data-id="element-199">
              <div className="w-2 h-2 rounded-full bg-emerald-300 animate-pulse" data-id="element-200"></div>
              <p className="font-medium" data-id="element-201">Active</p>
            </div>
          </div>
        </div>

        <button className="flex items-center space-x-2 text-sm font-medium text-teal-100 hover:text-white transition-colors" data-id="element-202">
          <Download className="w-4 h-4" data-id="element-203" />
          <span data-id="element-204">Download PDF</span>
        </button>
      </div>

      {/* Available */}
      <h3 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-3" data-id="element-205">
        Available
      </h3>
      <div className="grid gap-3 mb-6" data-id="element-206">
        {permits.map((permit, i) => <motion.div key={permit.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.05
      }} className="card p-4 flex items-center justify-between" data-id="element-207">
            <div data-id="element-208">
              <h4 className="font-medium text-[var(--text-primary)]" data-id="element-209">
                {permit.name}
              </h4>
              <p className="text-sm text-[var(--text-muted)]" data-id="element-210">{permit.desc}</p>
            </div>
            <div className="flex items-center space-x-3" data-id="element-211">
              <div className="text-right" data-id="element-212">
                <p className="font-semibold text-[var(--accent)]" data-id="element-213">
                  ${permit.price}
                </p>
                <p className="text-xs text-[var(--text-muted)]" data-id="element-214">
                  {permit.duration}
                </p>
              </div>
              <button onClick={() => {
            setSelectedPermit(permit);
            setShowModal(true);
          }} className="p-2 rounded-xl bg-[var(--bg-secondary)] hover:bg-[var(--accent-light)] hover:text-[var(--accent)] transition-colors" data-id="element-215">
                <Plus className="w-5 h-5" data-id="element-216" />
              </button>
            </div>
          </motion.div>)}
      </div>

      {/* History */}
      <h3 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-3" data-id="element-217">
        History
      </h3>
      <div className="space-y-2" data-id="element-218">
        {[2023, 2022].map(year => <div key={year} className="card p-4 flex items-center justify-between opacity-60" data-id="element-219">
            <div className="flex items-center space-x-3" data-id="element-220">
              <div className="p-2 rounded-xl bg-[var(--bg-secondary)]" data-id="element-221">
                <Calendar className="w-4 h-4 text-[var(--text-muted)]" data-id="element-222" />
              </div>
              <div data-id="element-223">
                <p className="font-medium text-[var(--text-primary)]" data-id="element-224">
                  Annual License
                </p>
                <p className="text-sm text-[var(--text-muted)]" data-id="element-225">
                  {year} · Expired
                </p>
              </div>
            </div>
          </div>)}
      </div>

      {/* Modal */}
      <AnimatePresence data-id="element-226">
        {showModal && selectedPermit && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-227">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-228" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} className="relative w-full max-w-sm float-card p-6 text-center" data-id="element-229">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-[var(--accent-light)] flex items-center justify-center" data-id="element-230">
                <Check className="w-7 h-7 text-[var(--accent)]" data-id="element-231" />
              </div>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-1" data-id="element-232">
                Purchase {selectedPermit.name}
              </h2>
              <p className="text-[var(--text-muted)] text-sm mb-6" data-id="element-233">
                ${selectedPermit.price} · {selectedPermit.duration}
              </p>
              <button onClick={() => setShowModal(false)} className="w-full btn-accent py-3 mb-2" data-id="element-234">
                Confirm Purchase
              </button>
              <button onClick={() => setShowModal(false)} className="w-full py-3 text-[var(--text-muted)] text-sm hover:text-[var(--text-primary)] transition-colors" data-id="element-235">
                Cancel
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}